var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#E22022"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 38C25.5 38.8284 26.1716 39.5 27 39.5C27.8284 39.5 28.5 38.8284 28.5 38L25.5 38ZM28.0607 15.9393C27.4749 15.3536 26.5251 15.3536 25.9393 15.9393L16.3934 25.4853C15.8076 26.0711 15.8076 27.0208 16.3934 27.6066C16.9792 28.1924 17.9289 28.1924 18.5147 27.6066L27 19.1213L35.4853 27.6066C36.0711 28.1924 37.0208 28.1924 37.6066 27.6066C38.1924 27.0208 38.1924 26.0711 37.6066 25.4853L28.0607 15.9393ZM28.5 38L28.5 17L25.5 17L25.5 38L28.5 38Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.ccc34786fade2d3ad8243f6288b89032.svg";
export { ForwardRef as ReactComponent };